import { createContext, useContext, useEffect, useState } from "react";

const NetworkContext = createContext({ ready: true, online: true, apiOnline: true });

export function NetworkProvider({ children }) {
    const [online, setOnline] = useState(navigator.onLine);
    const [apiOnline, setApiOnline] = useState(navigator.onLine);

    useEffect(() => {
        const handleOnline = () => {
            setOnline(true);
            setApiOnline(true); // otimista: assume que servidor voltou junto com a rede
        };
        const handleOffline = () => {
            setOnline(false);
            setApiOnline(false);
        };
        const handleApiStatus = (e) => setApiOnline(e.detail.online);

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);
        window.addEventListener("api-status", handleApiStatus);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
            window.removeEventListener("api-status", handleApiStatus);
        };
    }, []);

    return (
        <NetworkContext.Provider value={{ online, apiOnline, ready: online && apiOnline }}>
            {children}
        </NetworkContext.Provider>
    );
}

export function useNetwork() {
    return useContext(NetworkContext);
}
